import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitemComponent } from '../app-menuitem/app-menuitem.component';
import { ModuleService } from '../../../app/service/module-service/module.service';
import { LoginService } from '../../../app/service/auth-service/login.service';
import { Observable, Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { DividerModule } from 'primeng/divider';
import { User } from '../../interface';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitemComponent, RouterModule, DividerModule, NgIf],
  templateUrl: './app-menu.component.html',
  styleUrl: './app-menu.component.scss'
})
export class AppMenuComponent implements OnInit, OnDestroy {
  model$!: Observable<MenuItem[]>;   // comes from ModuleService
  currentUser: User | null = null;
  private userSubscription: Subscription = new Subscription();

  constructor(
    private moduleService: ModuleService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    // Sidebar model = modules + templates section
    this.model$ = this.moduleService.modules$;

    // Keep track of current user for showing email in sidebar header
    this.userSubscription = this.loginService.authUser$.subscribe(
      (user: User | null) => {
        this.currentUser = user;
      }
    );
  }

  ngOnDestroy() {
    this.userSubscription?.unsubscribe();
  }
}
